import landlineMask from './landline';
import mobileMask from './mobile';

// (00) 0000-0000
// (00) 90000-0000
const mask = function (value) {
    const sanitized = value.replace(/\D/g, '');

    if ((sanitized.length > 2) && (+sanitized[2] === 9)) {
        return mobileMask.mask;
    }

    return landlineMask.mask;
};

export default {
    mask: mask,
    guide: false,
    keepCharPositions: true,
    placeholderChar: '\u2000',
};
